import { render, staticRenderFns } from "./Recommend.vue?vue&type=template&id=18119a8c&scoped=true"
import script from "./Recommend.vue?vue&type=script&lang=js"
export * from "./Recommend.vue?vue&type=script&lang=js"
import style0 from "./Recommend.vue?vue&type=style&index=0&id=18119a8c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18119a8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18119a8c')) {
      api.createRecord('18119a8c', component.options)
    } else {
      api.reload('18119a8c', component.options)
    }
    module.hot.accept("./Recommend.vue?vue&type=template&id=18119a8c&scoped=true", function () {
      api.rerender('18119a8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/homepage/components/Recommend.vue"
export default component.exports